// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_K2n","cls2":"SimplePaperPodcast-cls2_406 SimplePaperPodcast-cls1_K2n"};